import { getLocale } from "../runtime";

const sv_campaigns = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Kampanjer`
};

const campaigns = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_campaigns(inputs)
	return "campaigns";
};

export { campaigns as "campaigns" };